import type { PdfDocumentSource } from './types';

function copyPdfBytes(data: ArrayBuffer | Uint8Array): Uint8Array<ArrayBuffer> {
  const copy = new Uint8Array(data.byteLength);
  copy.set(data instanceof Uint8Array ? data : new Uint8Array(data));
  return copy;
}

export function toPdfDocumentInput(
  source: PdfDocumentSource
): { url: string } | { data: Uint8Array } {
  if (source.type === 'url') {
    return { url: source.url };
  }
  return {
    data: copyPdfBytes(source.data),
  };
}

export function getPdfSourceKey(
  source: PdfDocumentSource
): string | ArrayBuffer | Uint8Array {
  return source.type === 'url' ? source.url : source.data;
}

export function toPdfBlob(source: PdfDocumentSource): Blob | null {
  if (source.type !== 'bytes') {
    return null;
  }
  return new Blob([copyPdfBytes(source.data)], { type: 'application/pdf' });
}
